import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-issue-seller-address',
  templateUrl: './issue-seller-address.component.html',
  styleUrls: ['./issue-seller-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IssueSellerAddressComponent implements OnInit { 
  contractData: any[] = [];
  advtFormBeans: any[] = [];
  advtVBTotal: number = 0;
  advtFormBean: any;
  advtBrieflyFormBeans: any[] = [];
  Address: any[] = [];
  advtBrieflyTotal: number = 0;
  advtMonthwiseFormBeans: any[] = [];
  GSTfullreportFormBeans: any[] = [];
  advtMonthwiseTotal: number = 0;
  grandtotalcontract: number = 0;
  getdeliverytype: any;
  totalrepsubhilhadigital: any;
  totalrepsubhilhamagzine: any;
  post_total_ROR: any;
  advtGroup: any;
  months: any;
  issueDates: any;
  contractDetailsForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<IssueSellerAddressComponent>,
    @Inject(MAT_DIALOG_DATA) public data1: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {
    this.contractDetailsForm = this.fb.group({
      start: ['', Validators.required],
      end: ['', Validators.required],
      // Add other form controls if needed
    });
  }

  ngOnInit(): void {
    this.filters();
  }

  filters(): void {
    // Check if repName is not empty and convert to array if necessary
    let repname: any = this.data1['repName'] || '';

    if (repname !== '') {
      repname = [repname]; // Ensure repname is always an array
    }

    const req: any = {
      "rep_name": repname,
      "start_date": this.data1['startDate'],
      "end_date": this.data1['endDate'],
      "off_rep_name": this.data1['offRepName'],
      "advt_name": this.data1['name'],
      "issue_date": this.data1['issueDates1'],
    };

    this.service.getAllissuesellerAdd(req).subscribe(
      (data1: any) => {
        this.Address = data1;
        console.log("Final Address array:", this.Address);
        this.cdr.markForCheck(); // Trigger change detection to update the view
      },
      (error) => {
        console.error("Error fetching addresses:", error);
      }
    );
  }
}
